module.exports = __webpack_public_path__ + "media/images/chair-db9593df86429762bbe667c9436ee8d0.png";